import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { useLang } from "@/lib/LanguageContext";
import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";

const COPY = {
  en: { title: "This page does not exist.", text: "The address may be incorrect, or the page may have been withdrawn.", home: "Back to the home page", services: "See our services" },
  fr: { title: "Cette page n'existe pas.", text: "L'adresse est peut-être incorrecte, ou la page a été retirée.", home: "Retour à l'accueil", services: "Voir nos services" },
};

export default function NotFoundPage() {
  const { lang } = useLang();
  const c = COPY[lang];
  return (
    <PageShell headerLight={false}>
      <Seo title="Page not found | Book & Smile" description={c.text} noindex />
      <section data-testid="not-found-page" className="min-h-[70vh] flex items-center px-6 lg:px-10 pt-32 pb-20">
        <div className="max-w-3xl mx-auto">
          <p className="eyebrow">404</p>
          <h1 className="font-serif mt-6 text-4xl sm:text-5xl lg:text-6xl font-light text-stone-900 leading-tight">{c.title}</h1>
          <p className="mt-6 text-stone-600 text-base md:text-lg leading-relaxed">{c.text}</p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link data-testid="not-found-home" to="/" className="inline-flex items-center gap-3 bg-slate-900 text-stone-50 px-8 py-4 text-sm font-medium hover:bg-slate-800 transition-colors">
              {c.home} <ArrowRight size={16} />
            </Link>
            <Link data-testid="not-found-services" to="/services" className="inline-flex items-center gap-2 px-8 py-4 text-sm text-stone-800 border border-stone-300 hover:border-stone-900 transition-colors">
              {c.services}
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
